<script>
import { mapGetters } from 'vuex';

export default {
    name: 'CloudFooter',
    mounted() { },
    methods: {
        onDataLoaded(data) {
            this.menuData = data.data;
            this.isLoading = false;
        },
    },
    computed: {
        ...mapGetters({
            menuData: 'getFooterNav',
            isLoading: 'getFooterNavIsLoading',
        }),
    }
};
</script>

<template>
    <footer class="cloud-footer">
        <div class="cloud-footer__main">
            <p class="cloud-footer__claim">{{ $t('siteFooter.claim') }}</p>
            <div class="cloud-footer__imprint">
                <h4 class="cloud-footer__imprint__owner__title">{{ $t('siteFooter.ownerTitle') }}</h4>
                <a href="https://www.guido-fluri-stiftung.ch/" target="_blank" class="cloud-footer__imprint__owner__link">
                    <img class="cloud-footer__imprint__owner__logo" src="../assets/images/logo-gfs-cloud-footer.svg" alt="Logo Guido Fluri Stiftung">
                </a>
            </div>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
.cloud-footer {
    width: 100%;
    box-sizing: border-box;
    padding: 0 5rem 2.6rem;

    @include breakpoint("sm-down") {
        padding: 0 3rem 2.2rem;
    }

    @include breakpoint("xs-down") {
        padding: 0 2rem 0.16rem;
    }
}
.cloud-footer__main {
    display: flex;
    justify-content: space-between;
    
    @include breakpoint("sm-down") {
        align-items: flex-end;
    }
}
.cloud-footer__claim {
    display: block;
    flex: 1;
    max-width: 29.6rem;
    margin: 0.4rem 0;
    font-size: 1.6rem;
    letter-spacing: 0.047rem;
    line-height: 1.4;
    text-transform: uppercase;
    color: $color-primary-alt;

    @include breakpoint("xs-down") {
        display: none;
    }
}

.cloud-footer__imprint {
    display: block;
    text-align: right;
    margin-left: 4.2rem;

    @include breakpoint("xs-down") {
        margin-left: 0;
        margin-bottom: 0.32rem;
        text-align: left;
    }
}
.cloud-footer__imprint__owner {
    max-width: 32rem;
    min-width: 28.8rem;
    margin-bottom: 2.4rem;
}
.cloud-footer__imprint__owner__title {
    margin: 0 0 0.52rem;
    font-size: 1.4rem;
    font-weight: 300;

    @include breakpoint('xs-down') {
        display: none;
    }
}
.cloud-footer__imprint__owner__logo {
    width: 20.4rem;

    @include breakpoint('xs-down') {
        width: 14.16rem;
        opacity: 0.7;
    }
}
</style>
